module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Exclusive","flags":["TRACK"],"track":"Exclusive"}}